// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.d3-organ-intel-panel {
  background: #0f172a;
  color: #e5e7eb;
  border-radius: 24px;
  padding: 18px;
  border: 1px solid rgba(148, 163, 184, 0.25);
  min-height: 520px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.d3-panel-header {
  display: flex;
  justify-content: space-between;
  gap: 14px;
  align-items: flex-start;
}

.d3-panel-header h3 {
  margin: 0;
  font-size: 18px;
}

.d3-panel-header p {
  margin: 4px 0 0;
  color: #94a3b8;
  font-size: 12px;
}

.d3-panel-header button,
.tree-toolbar button {
  border: 0;
  background: #635bff;
  color: #fff;
  border-radius: 12px;
  padding: 9px 11px;
  font-weight: 900;
  cursor: pointer;
  white-space: nowrap;
}

.d3-panel-header button:disabled,
.tree-toolbar button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.tree-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.tree-layout-toggle {
  margin-left: auto;
  display: flex;
  gap: 6px;
  background: rgba(255, 255, 255, 0.06);
  padding: 5px;
  border-radius: 14px;
}

.tree-layout-toggle button {
  background: transparent;
  color: #cbd5e1;
  padding: 8px 10px;
}

.tree-layout-toggle button.active {
  background: #818cf8;
  color: #fff;
}

.d3-tree-scroll {
  height: 360px;
  overflow: hidden;
  border-radius: 16px;
  background:
    linear-gradient(rgba(255,255,255,0.035) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255,255,255,0.035) 1px, transparent 1px),
    #020617;
  background-size: 28px 28px;
  border: 1px solid rgba(148, 163, 184, 0.18);
}

.d3-organ-tree-svg {
  display: block;
  width: 100%;
  height: 100%;
  font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  cursor: grab;
}

.d3-organ-tree-svg:active {
  cursor: grabbing;
}

.tree-link {
  shape-rendering: geometricPrecision;
}

.tree-node circle {
  transition: all 0.18s ease;
}

.tree-node:hover circle {
  stroke: #ffffff;
  stroke-width: 3;
}

.tree-node-label {
  fill: #e5e7eb;
  font-size: 12px;
  font-weight: 800;
  paint-order: stroke;
  stroke: #020617;
  stroke-width: 4px;
  stroke-linejoin: round;
}

.tree-node-organ .tree-node-label {
  font-size: 11px;
  font-weight: 700;
}

.tree-risk-label {
  fill: #cbd5e1;
  font-size: 9px;
  font-weight: 800;
  paint-order: stroke;
  stroke: #020617;
  stroke-width: 3px;
}

.selected-organ-detail {
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 16px;
  padding: 12px;
  background: rgba(255, 255, 255, 0.05);
}

.selected-organ-detail h4 {
  margin: 0 0 8px;
}

.selected-organ-detail p {
  color: #cbd5e1;
  font-size: 12px;
  line-height: 1.5;
}

.organ-risk-pill {
  display: inline-block;
  border-radius: 999px;
  padding: 5px 9px;
  font-size: 11px;
  font-weight: 900;
  margin-bottom: 8px;
}

.organ-risk-pill.high {
  background: rgba(239, 68, 68, 0.18);
  color: #fecaca;
}

.organ-risk-pill.moderate {
  background: rgba(245, 158, 11, 0.18);
  color: #fde68a;
}

.organ-risk-pill.low {
  background: rgba(34, 197, 94, 0.18);
  color: #bbf7d0;
}

.d3-chat-box {
  min-height: 260px;
  display: flex;
  flex-direction: column;
}

.d3-chat-box h4 {
  margin: 0 0 8px;
}

.d3-chat-messages {
  flex: 1 1;
  overflow-y: auto;
  border-radius: 14px;
  padding: 10px;
  background: #020617;
  border: 1px solid rgba(148, 163, 184, 0.16);
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 260px;
}

.d3-chat-msg {
  max-width: 92%;
  padding: 9px 10px;
  border-radius: 12px;
  font-size: 12px;
  line-height: 1.45;
  white-space: pre-wrap;
}

.d3-chat-msg.assistant {
  background: rgba(99, 102, 241, 0.18);
  color: #e0e7ff;
}

.d3-chat-msg.user {
  background: rgba(14, 165, 233, 0.18);
  color: #e0f2fe;
  align-self: flex-end;
}

.d3-chat-input {
  display: grid;
  grid-template-columns: 1fr 70px;
  gap: 8px;
  margin-top: 10px;
}

.d3-chat-input input {
  border: 1px solid rgba(148, 163, 184, 0.25);
  background: #020617;
  color: #e5e7eb;
  border-radius: 12px;
  padding: 11px 12px;
}

.d3-chat-input button {
  border: 0;
  border-radius: 12px;
  background: #635bff;
  color: white;
  font-weight: 900;
  cursor: pointer;
}

.tree-node rect {
  transition: all 0.18s ease;
}

.tree-node:hover rect {
  stroke: #ffffff;
  stroke-width: 2.5;
}

.tree-node-subpart .tree-node-label {
  font-size: 10px;
  font-weight: 700;
  fill: #cbd5e1;
}

.tree-node-root .tree-node-label,
.tree-node-system .tree-node-label {
  font-size: 12px;
  font-weight: 900;
}

.tree-node-organ .tree-node-label {
  font-size: 11px;
  font-weight: 800;
}

.tree-link {
  shape-rendering: geometricPrecision;
}

.d3-expanded-modal {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(2, 6, 23, 0.82);
  backdrop-filter: blur(14px);
  padding: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.d3-expanded-card {
  width: min(96vw, 1500px);
  height: min(92vh, 920px);
  background: #0f172a;
  border: 1px solid rgba(148, 163, 184, 0.3);
  border-radius: 28px;
  padding: 18px;
  box-shadow: 0 30px 90px rgba(0, 0, 0, 0.55);
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.d3-expanded-topbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.d3-expanded-topbar strong {
  display: block;
  color: #e5e7eb;
  font-size: 18px;
}

.d3-expanded-topbar span {
  display: block;
  color: #94a3b8;
  font-size: 12px;
  margin-top: 4px;
}

.d3-expanded-topbar button {
  border: 0;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  width: 42px;
  height: 42px;
  border-radius: 14px;
  font-size: 20px;
  cursor: pointer;
}

.tree-toolbar.expanded {
  flex-shrink: 0;
}

.d3-tree-scroll.expanded {
  flex: 1 1;
  height: auto;
  min-height: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/D3OrganTreePanel.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,2CAA2C;EAC3C,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,QAAQ;EACR,qCAAqC;EACrC,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB;;;WAGS;EACT,0BAA0B;EAC1B,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,wFAAwF;EACxF,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,gCAAgC;EAChC,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;AACf","sourcesContent":[".d3-organ-intel-panel {\n  background: #0f172a;\n  color: #e5e7eb;\n  border-radius: 24px;\n  padding: 18px;\n  border: 1px solid rgba(148, 163, 184, 0.25);\n  min-height: 520px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.d3-panel-header {\n  display: flex;\n  justify-content: space-between;\n  gap: 14px;\n  align-items: flex-start;\n}\n\n.d3-panel-header h3 {\n  margin: 0;\n  font-size: 18px;\n}\n\n.d3-panel-header p {\n  margin: 4px 0 0;\n  color: #94a3b8;\n  font-size: 12px;\n}\n\n.d3-panel-header button,\n.tree-toolbar button {\n  border: 0;\n  background: #635bff;\n  color: #fff;\n  border-radius: 12px;\n  padding: 9px 11px;\n  font-weight: 900;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.d3-panel-header button:disabled,\n.tree-toolbar button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.tree-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.tree-layout-toggle {\n  margin-left: auto;\n  display: flex;\n  gap: 6px;\n  background: rgba(255, 255, 255, 0.06);\n  padding: 5px;\n  border-radius: 14px;\n}\n\n.tree-layout-toggle button {\n  background: transparent;\n  color: #cbd5e1;\n  padding: 8px 10px;\n}\n\n.tree-layout-toggle button.active {\n  background: #818cf8;\n  color: #fff;\n}\n\n.d3-tree-scroll {\n  height: 360px;\n  overflow: hidden;\n  border-radius: 16px;\n  background:\n    linear-gradient(rgba(255,255,255,0.035) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(255,255,255,0.035) 1px, transparent 1px),\n    #020617;\n  background-size: 28px 28px;\n  border: 1px solid rgba(148, 163, 184, 0.18);\n}\n\n.d3-organ-tree-svg {\n  display: block;\n  width: 100%;\n  height: 100%;\n  font-family: Inter, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n  cursor: grab;\n}\n\n.d3-organ-tree-svg:active {\n  cursor: grabbing;\n}\n\n.tree-link {\n  shape-rendering: geometricPrecision;\n}\n\n.tree-node circle {\n  transition: all 0.18s ease;\n}\n\n.tree-node:hover circle {\n  stroke: #ffffff;\n  stroke-width: 3;\n}\n\n.tree-node-label {\n  fill: #e5e7eb;\n  font-size: 12px;\n  font-weight: 800;\n  paint-order: stroke;\n  stroke: #020617;\n  stroke-width: 4px;\n  stroke-linejoin: round;\n}\n\n.tree-node-organ .tree-node-label {\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.tree-risk-label {\n  fill: #cbd5e1;\n  font-size: 9px;\n  font-weight: 800;\n  paint-order: stroke;\n  stroke: #020617;\n  stroke-width: 3px;\n}\n\n.selected-organ-detail {\n  border: 1px solid rgba(148, 163, 184, 0.2);\n  border-radius: 16px;\n  padding: 12px;\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.selected-organ-detail h4 {\n  margin: 0 0 8px;\n}\n\n.selected-organ-detail p {\n  color: #cbd5e1;\n  font-size: 12px;\n  line-height: 1.5;\n}\n\n.organ-risk-pill {\n  display: inline-block;\n  border-radius: 999px;\n  padding: 5px 9px;\n  font-size: 11px;\n  font-weight: 900;\n  margin-bottom: 8px;\n}\n\n.organ-risk-pill.high {\n  background: rgba(239, 68, 68, 0.18);\n  color: #fecaca;\n}\n\n.organ-risk-pill.moderate {\n  background: rgba(245, 158, 11, 0.18);\n  color: #fde68a;\n}\n\n.organ-risk-pill.low {\n  background: rgba(34, 197, 94, 0.18);\n  color: #bbf7d0;\n}\n\n.d3-chat-box {\n  min-height: 260px;\n  display: flex;\n  flex-direction: column;\n}\n\n.d3-chat-box h4 {\n  margin: 0 0 8px;\n}\n\n.d3-chat-messages {\n  flex: 1;\n  overflow-y: auto;\n  border-radius: 14px;\n  padding: 10px;\n  background: #020617;\n  border: 1px solid rgba(148, 163, 184, 0.16);\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-height: 260px;\n}\n\n.d3-chat-msg {\n  max-width: 92%;\n  padding: 9px 10px;\n  border-radius: 12px;\n  font-size: 12px;\n  line-height: 1.45;\n  white-space: pre-wrap;\n}\n\n.d3-chat-msg.assistant {\n  background: rgba(99, 102, 241, 0.18);\n  color: #e0e7ff;\n}\n\n.d3-chat-msg.user {\n  background: rgba(14, 165, 233, 0.18);\n  color: #e0f2fe;\n  align-self: flex-end;\n}\n\n.d3-chat-input {\n  display: grid;\n  grid-template-columns: 1fr 70px;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.d3-chat-input input {\n  border: 1px solid rgba(148, 163, 184, 0.25);\n  background: #020617;\n  color: #e5e7eb;\n  border-radius: 12px;\n  padding: 11px 12px;\n}\n\n.d3-chat-input button {\n  border: 0;\n  border-radius: 12px;\n  background: #635bff;\n  color: white;\n  font-weight: 900;\n  cursor: pointer;\n}\n\n.tree-node rect {\n  transition: all 0.18s ease;\n}\n\n.tree-node:hover rect {\n  stroke: #ffffff;\n  stroke-width: 2.5;\n}\n\n.tree-node-subpart .tree-node-label {\n  font-size: 10px;\n  font-weight: 700;\n  fill: #cbd5e1;\n}\n\n.tree-node-root .tree-node-label,\n.tree-node-system .tree-node-label {\n  font-size: 12px;\n  font-weight: 900;\n}\n\n.tree-node-organ .tree-node-label {\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.tree-link {\n  shape-rendering: geometricPrecision;\n}\n\n.d3-expanded-modal {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  background: rgba(2, 6, 23, 0.82);\n  backdrop-filter: blur(14px);\n  padding: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.d3-expanded-card {\n  width: min(96vw, 1500px);\n  height: min(92vh, 920px);\n  background: #0f172a;\n  border: 1px solid rgba(148, 163, 184, 0.3);\n  border-radius: 28px;\n  padding: 18px;\n  box-shadow: 0 30px 90px rgba(0, 0, 0, 0.55);\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.d3-expanded-topbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.d3-expanded-topbar strong {\n  display: block;\n  color: #e5e7eb;\n  font-size: 18px;\n}\n\n.d3-expanded-topbar span {\n  display: block;\n  color: #94a3b8;\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n.d3-expanded-topbar button {\n  border: 0;\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n  width: 42px;\n  height: 42px;\n  border-radius: 14px;\n  font-size: 20px;\n  cursor: pointer;\n}\n\n.tree-toolbar.expanded {\n  flex-shrink: 0;\n}\n\n.d3-tree-scroll.expanded {\n  flex: 1;\n  height: auto;\n  min-height: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
